"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _context = require("../ConfigProvider/context");
var _fail_to_load = _interopRequireDefault(require("../../assets/images/fail_to_load.svg"));
var _types = require("../../types");
var _useTracking2 = require("../../hooks/useTracking");
var _Message = require("../Message");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Image = function Image(props) {
  var context = (0, _react.useContext)(_context.ConfigContext);
  var propsSrc = props.src,
    _props$fallback = props.fallback,
    fallback = _props$fallback === void 0 ? _fail_to_load.default : _props$fallback,
    fallbackText = props.fallbackText,
    _props$useFallback = props.useFallback,
    useFallback = _props$useFallback === void 0 ? true : _props$useFallback,
    className = props.className,
    maxWidth = props.maxWidth,
    maxHeight = props.maxHeight,
    minWidth = props.minWidth,
    minHeight = props.minHeight,
    height = props.height,
    width = props.width,
    margin = props.margin,
    preview = props.preview;
  var _useState = (0, _react.useState)(propsSrc),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    src = _useState2[0],
    setSrc = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isError = _useState4[0],
    setIsError = _useState4[1];
  var _useTracking = (0, _useTracking2.useTracking)(props),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick,
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var onError = function onError(err) {
    if (props.onError) {
      props.onError(err);
      return;
    }
    setIsError(true);
    if (useFallback) {
      setSrc(fallback);
    }
  };
  var onClick = function onClick() {
    var _props$onClick, _context$eventEmitter, _context$eventEmitter2;

    // 点击埋点
    trackingClick && tracker.click(trackingClick);
    props === null || props === void 0 ? void 0 : (_props$onClick = props.onClick) === null || _props$onClick === void 0 ? void 0 : _props$onClick.call(props, src);
    preview && (context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, _types.UIEvents.PreviewImage, {
      url: src
    }));
  };
  return isError && fallbackText ? /*#__PURE__*/_react.default.createElement(_Message.Message, {
    content: fallbackText
  }) : /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx2.default)((0, _getPrefixCls.getPrefixCls)('image'), className, (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('image__error'), isError))
  }, trackingImpressionProps), /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    onError: onError,
    onClick: onClick,
    style: {
      minWidth: minWidth,
      minHeight: minHeight,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      height: height,
      width: width,
      margin: margin
    }
  }));
};
exports.Image = Image;